module.exports = __webpack_public_path__ + "static/img/why-1.e7449329.jpg";